var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10897",
    "data-name": "Group 10897",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4056",
    "data-name": "Rectangle 4056",
    width: 19.838,
    height: 14.395,
    fill: "#ffffff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9577",
    "data-name": "Group 9577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    fill: "transparent",
    stroke: "#ffffff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820",
    transform: "translate(12.497 15.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33409",
    "data-name": "Path 33409",
    d: "M3.153,8.082H3.4q7.679,0,15.359,0a1.663,1.663,0,0,0,.418-.035.893.893,0,0,0-.2-1.753c-.084,0-.169,0-.253,0H3.145l-.075-.1a.749.749,0,0,0,.207-.1q2.26-2.248,4.513-4.5A.9.9,0,0,0,6.64.2a2.154,2.154,0,0,0-.169.159L.377,6.443a.92.92,0,0,0,0,1.481q3.07,3.065,6.139,6.131a.929.929,0,0,0,.951.306.9.9,0,0,0,.448-1.45c-.05-.059-.107-.112-.162-.166Q5.515,10.515,3.281,8.287a1.219,1.219,0,0,0-.189-.129l.061-.077",
    transform: "translate(0 0.001)",
    fill: "#ffffff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowWhite);
export default __webpack_public_path__ + "static/media/left_arrow_white.56269552d16a3b94468ac365f8b7b25e.svg";
export { ForwardRef as ReactComponent };